import { Switch } from "@mui/material";
import { Clinic } from "../../models";
import { SETTING_QUEUE_ENABLE_TELEHEALTH } from "../../constants";

interface params {
	clinics: Clinic[];
	handleSettingChange: (event: React.ChangeEvent) => void;
}
export const TelehealthCentresTable = ({
	clinics,
	handleSettingChange
}: params) => {
	const renderTableRow = (clinic: Clinic) => {
		const setting = clinic.clinicSettings?.find(
			(cs) => cs.settingName === SETTING_QUEUE_ENABLE_TELEHEALTH
		);
		if (!setting) {
			return <></>;
		}

		return (
			<tr key={clinic.amsId}>
				<td>{clinic.name}</td>
				<td align="left">
					<Switch
						id={setting.id.toString()}
						checked={setting.value === "1"}
						onChange={handleSettingChange}
						name={setting.settingName}
					/>
				</td>
			</tr>
		);
	};

	return (
		<>
			<div className="ch-l-text my-4">Telehealth Centres</div>
			<table className="ch-table w-full">
				<thead>
					<tr>
						<th>Centre</th>
						<th align="left">Telehealth Enabled</th>
					</tr>
				</thead>
				{clinics && (
					<tbody>{clinics.map((clinic) => renderTableRow(clinic))}</tbody>
				)}
			</table>
		</>
	);
};
